module.exports = __webpack_public_path__ + "static/img/dd-partner-07.dd72e96.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/dd-partner-07.jpg
// module id = Hx97
// module chunks = 1